import script from "./MobileDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileDetails.vue?vue&type=script&setup=true&lang=js"

import "./MobileDetails.vue?vue&type=style&index=0&id=fe9076bc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe9076bc"]])

export default __exports__